/* eslint-disable no-magic-numbers */

import lodash from 'lodash';

import {EASINGS} from '../../ecs/easingHelper';

/**
 * The name that signals this preset.
 * @const {string}
 */
export const PRESET_LETTER_RISE_OUT = 'letterRiseOut';

/**
 * The preset details.
 *
 * @type {{
 *   name: string,
 *   flow: string,
 *   details: Object.<string, {
 *     easing: string,
 *     parse: boolean,
 *     values: *|Array.<*>,
 *     time: {start: (string|number), end: (string|number)}
 *   }>,
 *   template: {}
 * }}
 */
export const letterRiseOutPresetDetails = {
  // The name of the preset.
  name: PRESET_LETTER_RISE_OUT,

  // A human friendly name for the preset.
  humanName: 'Letter - Rise Out',

  // The element names that this preset can be used for or true for all elements.
  elements: ['text'],

  // The preset direction: in, out, middle. This is used in the UI logic.
  flow: 'out',

  // Each property that will change during the transition.
  details: {
    'letter.translateY': {
      // The name of the easing this property will use.
      easing: EASINGS.easeOutExpo,

      // The start and end times for the transition of this property.
      time: {
        start: 'end.-2000',
        end: 'end.0',
      },

      // The value of the property that will change during the transition.
      values: [0, 30],

      // Whether or not to stagger the transition for each letter or the stagger delay in milliseconds.
      stagger: 50,

      // The amount of time in milliseconds that each letter will animate, or false to auto-calculate.
      staggerDuration: false,

      // Do not immediately set properties. wait until animation starts
      immediateRender: false
    },
    'letter.opacity': {
      // The name of the easing this property will use.
      easing: EASINGS.easeOutExpo,

      // The start and end times for the transition of this property.
      time: {
        start: 'end.-2000',
        end: 'end.0',
      },

      // The value of the property that will change during the transition.
      values: [1, 0],

      // Whether or not to stagger the transition for each letter or the stagger delay in milliseconds.
      stagger: 50,

      // The amount of time in milliseconds that each letter will animate, or false to auto-calculate.
      staggerDuration: false,

      // Do not immediately set properties. wait until animation starts
      immediateRender: false
    },
  },

  // How this preset can be used in the source (including optional parameters).
  // This will be turned into a JSON string, so no functions can be used.
  template: {
    preset: PRESET_LETTER_RISE_OUT,
    options: {},
  },
};

letterRiseOutPresetDetails.template.options = lodash.cloneDeep(letterRiseOutPresetDetails.details);

// This defines the key in the presets object.
export const presetName = PRESET_LETTER_RISE_OUT;

// This defines the value of the presets object.
export default letterRiseOutPresetDetails;
